import React, { useState, useEffect } from 'react';

function VoiceTest() {
  const [voices, setVoices] = useState([]);
  const [selectedVoice, setSelectedVoice] = useState('');
  const [testText, setTestText] = useState(
    'Hello! This is a test of the voice synthesis. How does this sound?'
  );

  useEffect(() => {
    // Get available voices
    const getVoices = () => {
      const allVoices = window.speechSynthesis.getVoices();

      // Filter for only the specific voices we want
      const clearVoices = allVoices.filter((voice) => {
        const name = voice.name.toLowerCase();
        const lang = voice.lang.toLowerCase();

        // Only include English voices
        const isEnglish = lang.startsWith('en');

        // Only include these specific voices (case insensitive)
        const isDesiredVoice =
          name.includes('samantha') ||
          name.includes('alex') ||
          name.includes('victoria') ||
          name.includes('enhanced');

        console.log(
          'Voice:',
          voice.name,
          'Lang:',
          voice.lang,
          'IsEnglish:',
          isEnglish,
          'IsDesired:',
          isDesiredVoice
        );

        return isEnglish && isDesiredVoice;
      });

      console.log(
        'All voices:',
        allVoices.map((v) => v.name)
      );
      console.log(
        'Filtered voices:',
        clearVoices.map((v) => v.name)
      );

      // If we don't get enough voices, show all English voices for debugging
      if (clearVoices.length < 2) {
        const allEnglishVoices = allVoices.filter((voice) =>
          voice.lang.toLowerCase().startsWith('en')
        );
        console.log(
          'Not enough filtered voices, showing all English voices:',
          allEnglishVoices.map((v) => v.name)
        );
        setVoices(allEnglishVoices);
        if (allEnglishVoices.length > 0) {
          setSelectedVoice(allEnglishVoices[0].name);
        }
      } else {
        setVoices(clearVoices);
        if (clearVoices.length > 0) {
          setSelectedVoice(clearVoices[0].name);
        }
      }
    };

    // Some browsers need a delay to load voices
    getVoices();
    setTimeout(getVoices, 1000);

    // Listen for voices loaded event
    window.speechSynthesis.onvoiceschanged = getVoices;
  }, []);

  const speak = (text, voiceName) => {
    window.speechSynthesis.cancel();
    const utterance = new SpeechSynthesisUtterance(text);
    utterance.voice = window.speechSynthesis
      .getVoices()
      .find((v) => v.name === voiceName);
    utterance.rate = 0.8;
    utterance.pitch = 1.1;
    window.speechSynthesis.speak(utterance);
  };

  const testVoice = () => {
    speak(testText, selectedVoice);
  };

  return (
    <div
      style={{
        padding: '20px',
        maxWidth: '600px',
        margin: '0 auto',
        fontFamily: 'Arial, sans-serif',
        color: '#fff',
        background:
          'linear-gradient(135deg, #0a0a0a 0%, #1a1a2e 50%, #16213e 100%)',
        minHeight: '100vh',
      }}
    >
      <h1>Voice Test</h1>

      <div style={{ marginBottom: '20px' }}>
        <label style={{ display: 'block', marginBottom: '10px' }}>
          Test Text:
        </label>
        <textarea
          value={testText}
          onChange={(e) => setTestText(e.target.value)}
          style={{
            width: '100%',
            height: '80px',
            padding: '10px',
            borderRadius: '5px',
            border: '1px solid #ccc',
            fontSize: '14px',
          }}
        />
      </div>

      <div style={{ marginBottom: '20px' }}>
        <label style={{ display: 'block', marginBottom: '10px' }}>
          Select Voice:
        </label>
        <select
          value={selectedVoice}
          onChange={(e) => setSelectedVoice(e.target.value)}
          style={{
            width: '100%',
            padding: '10px',
            borderRadius: '5px',
            border: '1px solid #ccc',
            fontSize: '14px',
          }}
        >
          {voices.map((voice, index) => (
            <option key={index} value={voice.name}>
              {voice.name} ({voice.lang}) - {voice.default ? 'Default' : ''}
            </option>
          ))}
        </select>
      </div>

      <button
        onClick={testVoice}
        style={{
          background: '#4169e1',
          color: '#fff',
          padding: '15px 30px',
          border: 'none',
          borderRadius: '10px',
          fontSize: '18px',
          fontWeight: '600',
          cursor: 'pointer',
          transition: 'background-color 0.3s ease',
        }}
        onMouseOver={(e) => (e.target.style.background = '#3151c1')}
        onMouseOut={(e) => (e.target.style.background = '#4169e1')}
      >
        Test Voice
      </button>

      <div style={{ marginTop: '30px' }}>
        <h3>Available Voices ({voices.length}):</h3>
        <div
          style={{
            maxHeight: '300px',
            overflowY: 'auto',
            border: '1px solid #ccc',
            borderRadius: '5px',
            padding: '10px',
            background: 'rgba(255,255,255,0.1)',
          }}
        >
          {voices.map((voice, index) => (
            <div
              key={index}
              style={{
                padding: '5px 0',
                borderBottom: '1px solid rgba(255,255,255,0.1)',
                fontSize: '14px',
              }}
            >
              <strong>{voice.name}</strong> - {voice.lang}
              {voice.default && (
                <span style={{ color: '#74b9ff' }}> (Default)</span>
              )}
            </div>
          ))}
        </div>
      </div>

      <div style={{ marginTop: '20px', fontSize: '14px', opacity: '0.8' }}>
        <p>
          <strong>Tips:</strong>
        </p>
        <ul>
          <li>
            Look for voices with "Enhanced" or "Premium" in the name for better
            quality
          </li>
          <li>English voices usually work best for the workout app</li>
          <li>Some voices may be faster or slower by default</li>
          <li>
            Test different voices to find one that sounds natural and clear
          </li>
        </ul>
      </div>
    </div>
  );
}

export default VoiceTest;
